import { siteConfig } from '../data/siteConfig'

type FooterLink = { label: string; href: string }

export function getFooterLinks(): FooterLink[] {
  const links: FooterLink[] = []
  if (siteConfig.supportEmail) {
    links.push({ label: 'Contact', href: `mailto:${siteConfig.supportEmail}` })
  }
  if (siteConfig.privacyUrl) links.push({ label: 'Privacy', href: siteConfig.privacyUrl })
  if (siteConfig.termsUrl) links.push({ label: 'Terms', href: siteConfig.termsUrl })
  if (siteConfig.refundPolicyUrl) {
    links.push({ label: 'Refund policy', href: siteConfig.refundPolicyUrl })
  }
  return links
}
